import React from 'react'
import axios from 'axios'
import Select from 'react-select'
import { bool } from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'
import Tooltip from '../../../Shared/Tooltip'

import TopDesignersTabs from './Components/TopDesignersTabs'

class TopDesigners extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      scope: 'week',
      isDataFetched: false,
      axiosSource: axios.CancelToken.source(),
    }

    this.fetchData = this.fetchData.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
  }

  componentDidMount() {
    this.fetchData(this.state.scope)
  }

  fetchData(designersScope) {
    return axios.get('/api/internal/seller_dashboard/top_designers', {
      params: { scope: designersScope },
      cancelToken: this.state.axiosSource.token,
    })
      .then((response) => this.onFetchSuccess(response))
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    return this.setState({
      data: response.data,
      isDataFetched: true,
    })
  }

  onSortChange(data) {
    this.setState({
      scope: data.value,
      isDataFetched: false,
    })

    this.fetchData(data.value)
  }

  render() {
    const sortSelectOptions = [
      { value: 'week', label: 'Last 7 days' },
      { value: 'month', label: 'Last 30 days' },
    ]
    const { newRoyaltyUi } = this.props

    const tabs = [
      ...(!newRoyaltyUi ? [
        { title: 'Reputation', slug: 'reputation', text: 'Designers ranked by gained Reputation' },
      ] : []),
      { title: 'Uploads', slug: 'uploads', text: 'Designers ranked by number of uploaded models' },
    ]

    return (
      <div className="row">
        <div className="col-12">
          <div className="card card--flat">
            <div className="dashboard-card dashboard-card--designers">
              <h3>
                <a href="/designers">Top Designers</a> <Tooltip
                  tooltipClassName="tooltip--medium"
                  id="dashboard__top-designers"
                  content="Top designers of the week"
                >
                  <Icon type={['far', 'question-circle']} color="grey" notSpaced />
                </Tooltip>
              </h3>
              <Select
                className="Select-new col-6"
                id="designers-filter"
                options={sortSelectOptions}
                onChange={this.onSortChange}
                value={this.state.scope}
                searchable={false}
                clearable={false}
              />
              {this.state.data.length > 0
                && <TopDesignersTabs isDataFetched={this.state.isDataFetched} data={this.state.data} tabs={tabs} />}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

TopDesigners.propTypes = {
  newRoyaltyUi: bool,
}

TopDesigners.defaultProps = {
  newRoyaltyUi: false,
}

export default TopDesigners
